export const RoutePaths = {
  root: "/",
  expertHome: "/expert",
  expertProfile: "/expert/profile",
  dashboard: "/dashboard",
  login: "/auth",
  verifyEmail: "/verify/email",
  expertScheduleSchedule: "/expert/schedule/schedule",
  expertScheduleTemplate: "/expert/schedule/template",
  expertScheduleReservationList: "/expert/schedule/reservationList",
  expertsCountry: "/experts/country",
  allExperts: "/AllExperts",
  favouriteExperts: "/favouriteExperts",
  lessons: "/lessons",
  createSchedule: "/createSchedule",
  reservedLessons:"/reservedLessons",
  lessonsPack: "/lessonsPack",
  selectedExpert: "/expert/view",
  newLesson: "/lessons/new",
  editLesson: "/lessons/edit",
  lessonsGroup: "/lessons/group",
  lessonsIndividual: "/lessons/individual",
  bankDetails: "/bank-details",
  settings: "/settings",
  editProfile: "/profile/edit",
  reservation: "/reservation",
  studentLessons: "/student/lessons",
  individualLessonsNotUsed: "/student/lessons/individual/notUsed",
  individualLessonsCompleted: "/student/lessons/individual/completed",
  individualLessonsReserved: "/student/lessons/individual/reserved",
  groupLessons: "/student/lessons/group",
  studentSelectReservationTimeSlot: "/student/select/reservation/timeslot",
  studentSelectTimeSlot: "/student/select/timeslot",
  expertRevenueManagement: "/expert/revenue",
  expertViewEnrollments: "/expert/view/enrollments",
  expertEnrollmentsLessonReport: "/expert/view/enrollments/lesson/report",
  studentPurchasePoints: "/student/purchase",
  passwordReset: "/password/reset",
  serviceAgreement: "/agreement",
  userGuide: "/userGuide",
  lessonPreview: "/lessons/preview",
  paymentPolicy: "/payment-policy",
  InstructorPolicy: "/instructor-policy",
  howToUseGuide: "/how-to-use-guide",
  termsOfService: "/terms-of-service",
  transactionLaw: "/transaction-law",
  privacyPolicy: "/privacy-policy",
  cancellationPolicy: "/cancellation-policy",
  expertRegisterInfo: "/teacher-register-info",
  expertRegisterSuccess: "/teacher-register-success",
  teacherDetails: "/teacher/details",
  expertRegisterConfirm: "/teacher-register-confirm",
  expertView: "/teacher/view",
  contactForm: "/contact",
  contactFormSuccess: "/contact-success"
};

const commonRoutes = [
  RoutePaths.editProfile,
  RoutePaths.root,
  RoutePaths.expertHome,
  RoutePaths.dashboard,
  RoutePaths.login,
  RoutePaths.verifyEmail,
  RoutePaths.settings,
  RoutePaths.expertsCountry,
  RoutePaths.selectedExpert,
  RoutePaths.allExperts,
  RoutePaths.favouriteExperts,
  RoutePaths.expertProfile,
  RoutePaths.expertRevenueManagement,
  RoutePaths.passwordReset,
  RoutePaths.serviceAgreement,
  RoutePaths.userGuide,
  RoutePaths.paymentPolicy,
  RoutePaths.InstructorPolicy,
  RoutePaths.howToUseGuide,
  RoutePaths.termsOfService,
  RoutePaths.transactionLaw,
  RoutePaths.privacyPolicy,
  RoutePaths.cancellationPolicy,
  RoutePaths.expertRegisterInfo,
  RoutePaths.expertRegisterSuccess,
  RoutePaths.teacherDetails,
  RoutePaths.expertRegisterInfo,
  RoutePaths.contactForm,
  RoutePaths.contactFormSuccess
];

export const expertRoutePaths = [
  ...commonRoutes,
  RoutePaths.expertScheduleSchedule,
  RoutePaths.expertScheduleTemplate,
  RoutePaths.expertScheduleReservationList,
  RoutePaths.lessons,
  RoutePaths.lessonsPack,
  RoutePaths.newLesson,
  RoutePaths.lessonsGroup,
  RoutePaths.lessonsIndividual,
  RoutePaths.bankDetails,
  RoutePaths.editLesson,
  RoutePaths.expertViewEnrollments,
  RoutePaths.expertEnrollmentsLessonReport,
  RoutePaths.expertRegisterInfo,
  RoutePaths.expertRegisterConfirm,
  RoutePaths.expertRegisterSuccess,
  RoutePaths.expertView,
  RoutePaths.lessonPreview,
  RoutePaths.reservedLessons,
  RoutePaths.createSchedule
];

export const studentRoutePaths = [
  ...commonRoutes,
  RoutePaths.reservation,
  RoutePaths.studentSelectReservationTimeSlot,
  RoutePaths.studentSelectTimeSlot,
  RoutePaths.studentLessons,
  RoutePaths.individualLessonsNotUsed,
  RoutePaths.individualLessonsCompleted,
  RoutePaths.individualLessonsReserved,
  RoutePaths.groupLessons,
  RoutePaths.studentPurchasePoints,
  RoutePaths.lessonPreview
];

export default RoutePaths;
